import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRouteSnapshot, Params, Resolve, RouterStateSnapshot} from '@angular/router';
import {BehaviorSubject, Observable} from 'rxjs';
import {Entity, Project} from './product.model';
import {AttributeValue} from 'app/components/attributes/attributes.model';
import {SystemService} from '../../services/system.service';


@Injectable()
export class ProductService implements Resolve<any>
{
    routeParams: any;
    private queryParams: Params;
    product: any;

    onProductChanged: BehaviorSubject<any>;
    attributeValues: AttributeValue[];

    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(private _httpClient: HttpClient, private _system: SystemService)
    {
        // Set the defaults
        this.onProductChanged = new BehaviorSubject({});
    }

    /**
     * Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
    {
        this.routeParams = route.params;
        this.queryParams = route.queryParams;
        return new Promise((resolve, reject) => {
            Promise.all([
                this.getProduct()
            ]).then(
                () => {
                    resolve('');
                },
                reject
            );
        });
    }


    getAProduct(id: number): Observable<Project> {
        return this._httpClient.get<Project>('/ypm/api/fm/project/' + id);
    }

    /**
     * Get product
     *
     * @returns {Promise<any>}
     */
    getProduct(): Promise<any>
    {
        return new Promise((resolve, reject) => {
            if ( this.routeParams.id === 'new' )
            {
                this.onProductChanged.next(null);
                let project = new Project();
                if (this.queryParams.status) {
                    project.status = this.queryParams.status;
                }
                if (this.queryParams.type) {
                    project = this.getDefaultProject(this.queryParams.type);
                }
                this.onProductChanged.next({product: project, attributes: project.attributes});
                resolve({product: project, attributes: project.attributes});
            }
            else
            {
                // this.getChildren(this.routeParams.id)
                //     .subscribe(
                //         resp => console.log(resp)
                //     );
                this._httpClient.get('/ypm/api/fm/project/' + this.routeParams.id)
                    .subscribe(response => {
                        this.getAttributes('Project', this.routeParams.id).subscribe(
                            resp => {
                                // this.product = response;
                                const attributeValues: AttributeValue[] = [];
                                resp.forEach(value => {
                                    const attValue: AttributeValue = new AttributeValue(value);
                                    attributeValues.push(attValue);
                                });
                                this.onProductChanged.next({product: new Project(response), attributes: attributeValues});
                                this.attributeValues = attributeValues;
                                resolve({product: new Project(response), attributes: attributeValues});

                            });

                    }, reject);
            }
        });
    }





    getProjectTypes(): Observable<Entity[]>{
        // const headers = { 'withCredentials':'true' }
        return this._httpClient.get<Entity[]>('/ypm/api/fm/type/Project');
    }

    getAttributes(type: string, id: string): Observable<AttributeValue[]>{
        // const headers = { 'withCredentials':'true' }
        return this._httpClient.get<AttributeValue[]>('/ypm/api/fm/attributes/' + type + '/' + id);
    }



    /**
     * Bulk update projects
     *
     * @param ids
     * @param data
     */
    bulkUpdateProjects(ids: number[], data: any): Observable<any>
    {
        return this._httpClient.post('/ypm/api/fm/project/bulk-update',
            { ids: ids,
                status: data.status,
                area: data.area,
                client: data.client,
                attributes: data.attributes});
    }

    /**
     * Save product
     *
     * @param product
     * @returns {Promise<any>}
     */
    saveProduct(product): Observable<Project>
    {
        return this._httpClient.post<Project>('/ypm/api/fm/project' , product);
    }

    countHHProduct(product): Observable<void>
    {
        return this._httpClient.get<void>('/ypm/api/fm/hhCountProject/' + product.id);
    }

    deleteProduct(product): Observable<void>
    {
        return this._httpClient.delete<void>('/ypm/api/fm/project/' + product.id);
    }

    /**
     * Add product
     *
     * @param product
     *
     */
    addProduct(product): Observable<Project>
    {
        product.createdBy = null;
        product.approved = false;
        if (product.team == null && this._system.teams.length === 1 ) {
            product.team = this._system.teams[0];
        }
        return this._httpClient.post<Project>('/ypm/api/fm/project', product);
    }


    private getDefaultProject(type: string): any {
        return JSON.parse('{' +
            '    "id": 0,' +
            '    "projectNumber": 0,' +
            '    "type": {' +
            '        "id": 1,' +
            '        "name": "Calibración",' +
            '        "type": "Project"' +
            '    },' +
            '    "team": {' +
            '        "enabled": true,' +
            '        "id": 1301,' +
            '        "name": "Todos"' +
            '    },' +
            '    "status": "PARA CALIBRAR",' +
            '    ' +
            '    "attributes": [' +
            '        {' +
            '            "id": null,' +
            '            "attributeType": {' +
            '                "basicType": "DateType",' +
            '                "id": 1351,' +
            '                "name": "Fecha Recepción",' +
            '                "percentage": false' +
            '            },' +
            '            "name": "Fecha Recepción",' +
            '            "value": "' + this.today() + '" ' +
            '        },' +
            '        {' +
            '            "id": null,' +
            '            "attributeType": {' +
            '                "basicType": "DateType",' +
            '                "id": 1352,' +
            '                "name": "Fecha Calibración",' +
            '                "percentage": false' +
            '            },' +
            '            "name": "Fecha Calibración",' +
            '            "value": ""' +
            '        },' +
            '        {' +
            '            "id": null,' +
            '            "attributeType": {' +
            '                "basicType": "StringListType",' +
            '                "id": 1353,' +
            '                "name": "Vigencia",' +
            '                "percentage": false,' +
            '                "candidateValues": [ "1 año", "2 años", "3 años", "4 años", "5 años", "Define cliente"]' +
            '            },' +
            '            "name": "Vigencia",' +
            '            "value": "1 año"' +
            '        },' +
            '        {' +
            '            "id": null,' +
            '            "attributeType": {' +
            '                "basicType": "DateType",' +
            '                "id": 1354,' +
            '                "name": "Fecha Vencimiento",' +
            '                "percentage": false' +
            '            },' +
            '            "name": "Fecha Vencimiento",' +
            '            "value": ""' +
            '        },' +
            '        {' +
            '            "id": null,' +
            '            "attributeType": {' +
            '                "basicType": "DateType",' +
            '                "id": 1355,' +
            '                "name": "Fecha Emisión",' +
            '                "percentage": false' +
            '            },' +
            '            "name": "Fecha Emisión",' +
            '            "value": ""' +
            '        },' +
            '        {' +
            '            "id": null,' +
            '            "attributeType": {' +
            '                "basicType": "DateType",' +
            '                "id": 1356,' +
            '                "name": "Fecha envío informe",' +
            '                "percentage": false' +
            '            },' +
            '            "name": "Fecha envío informe",' +
            '            "value": ""' +
            '        },' +
            '        {' +
            '            "id": null,' +
            '            "attributeType": {' +
            '                "basicType": "StringListType",' +
            '                "candidateValues": [' +
            '                    "Calibración Normal",' +
            '                    "Calibración Urgente",' +
            '                    "Reparación",' +
            '                    "Reparación + Calibración",' +
            '                    "Ajuste",' +
            '                    "Ensayo",' +
            '                    "Alquiler",' +
            '                    "Verificación",' +
            '                    "Calibración + Ajuste",' +
            '                    "Suministro",' +
            '                    "Rechazado",' +
            '                    "Urgente + Ajuste",' +
            '                    "Especial",' +
            '                    "Revisar"' +
            '                ],' +
            '                "defaultValue": "Calibración Normal",' +
            '                "id": 1357,' +
            '                "name": "Tipo de servicio",' +
            '                "percentage": false' +
            '            },' +
            '            "name": "Tipo de servicio",' +
            '            "value": "Calibración Normal"' +
            '        },' +
            '       {' +
            '           "attributeType": {' +
            '                       "basicType": "StringType", ' +
            '                       "id": 61051, ' +
            '                       "multiLine": false, ' +
            '                       "name": "Cliente en Informe", ' +
            '                       "percentage": false' +
            '                       },' +
            '           "id": null,' +
            '           "name": "Cliente en Informe",' +
            '           "value": ""' +
            '       }' +
            '    ]' +
            '}');
    }

    private today(): string {
        const today: Date = new Date();
        const day: string = ('0' + today.getDate()).slice(-2);
        const month: string = ('0' + (today.getMonth() + 1)).slice(-2);
        const year: string = today.getFullYear().toString();
        return year + '-' + month + '-' + day;
    }

}
